import(/* webpackMode: "eager" */ "/app/src/app/portfolio/page.tsx");
